<template>
  <div>
    <v-slide-x-transition>
      <div
        v-if="show"
        :class="{'text-xs-center': centered}"
      >
        <v-pagination
          ref="pagination"
          class="custom-pagination-controls mt-2 mb-1"
          :class="{'hide-icons': hideIcons}"
          :value="page"
          :circle="circle"
          :length="numPages"
          @input="onPageButtonClicked"
        />
      </div>
    </v-slide-x-transition>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    numPages: {
      type: Number,
      required: true,
    },
    centered: {
      type: Boolean,
      default: true,
    },
    circle: {
      type: Boolean,
      default: false,
    },
    hideIcons: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    /**
     * Patch the VPagination onResize handler that computes maxButtons.
     *
     * Our customization excludes the left/right arrow buttons with
     * hideIcons=true, so in that case we have some more space available
     * for additional page buttons.
     *
     * See: https://github.com/vuetifyjs/vuetify/blob/v1.5.24/packages/vuetify/src/components/VPagination/VPagination.ts#L111-L117
     */
    show: {
      immediate: true,
      handler: function (show) {
        if (show && this.hideIcons) {
          this.$nextTick(() => {
            this.$refs.pagination.onResize = () => {
              const that = this.$refs.pagination;
              const width =
                that.$el && that.$el.parentElement
                  ? that.$el.parentElement.clientWidth
                  : window.innerWidth;
              that.maxButtons = Math.floor((width - 12) / 42);
            };
            this.$nextTick(() => {
              this.$refs.pagination.onResize();
            });
          });
        }
      },
    },
  },
  methods: {
    onPageButtonClicked(index) {
      this.$emit('update:page', index);
    },
  },
};
</script>

<style lang="stylus">
$pagination-box-shadow = 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
$smaller-margin = 2px

.custom-pagination-controls:hover
  box-shadow: none !important

.custom-pagination-controls
.v-pagination__item:not(.v-pagination__item--active)
    box-shadow: none
    &:hover
      box-shadow: $pagination-box-shadow

.custom-pagination-controls .v-pagination__navigation
    box-shadow: none
    &:hover
      box-shadow: $pagination-box-shadow


.custom-pagination-controls.hide-icons .v-pagination__navigation
    display: none

@media(max-width: 599px)
  .custom-pagination-controls .v-pagination__item
    width: 1.75rem
    height: 2rem
    margin-left: $smaller-margin
    margin-right: $smaller-margin

  .custom-pagination-controls .v-pagination__navigation
    margin-left: $smaller-margin
    margin-right: $smaller-margin
</style>



// WEBPACK FOOTER //
// src/components/PaginationControls.vue